<script setup>
import Toast from 'primevue/toast';
import { useFlashMessages } from '@/Composables/useFlashMessages';

// Initialize flash message handling
useFlashMessages();
</script>

<template>
    <!-- Global Toast - positioned at bottom center like a snackbar -->
    <Toast position="bottom-center" />

    <!-- Page content -->
    <slot />
</template>

<style>
/* Custom toast styling for snackbar-like appearance */
.p-toast.p-toast-bottom-center {
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    max-width: 90vw;
}

.p-toast .p-toast-message {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.p-toast .p-toast-message-content {
    padding: 12px 16px;
}

/* Make it more compact/snackbar-like */
.p-toast .p-toast-summary {
    font-weight: 600;
    font-size: 0.875rem;
}

.p-toast .p-toast-detail {
    font-size: 0.875rem;
    margin-top: 2px;
}
</style>
